import { useState, useEffect } from 'react';
import assignmentAttachmentServices from 'ApiService/Student/assignmentAttachmentServices';

const FILE_BASE = process.env.REACT_APP_API_BASE_URL;

const StudentAttachmentsView = ({ assignmentId }) => {
  const [attachments, setAttachments] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!assignmentId) return;
    const fetch = async () => {
      setLoading(true);
      try {
        const res = await assignmentAttachmentServices.getAttachmentsByAssignment(assignmentId);
        if (res.data.success) setAttachments(res.data.data);
      } catch {
        // silent
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [assignmentId]);

  if (loading) {
    return <p className="text-xs text-gray-500">Loading shared files...</p>;
  }

  if (attachments.length === 0) return null;

  const iconMap = {
    image: '📷',
    voice: '🎙',
    video: '🎥',
    document: '📎',
  };

  return (
    <div className="rounded-lg border border-gray-200 p-3 dark:border-white/10">
      <h3 className="mb-2 text-sm font-semibold text-gray-700 dark:text-gray-300">
        HR Shared Files
      </h3>
      <div className="space-y-2">
        {attachments.map((att) => {
          const fileUrl = `${FILE_BASE}${att.url}`;
          const icon = iconMap[att.type] || '📄';
          return (
            <div key={att._id} className="flex items-start gap-2 rounded-md bg-gray-50 p-2 dark:bg-navy-700">
              <span className="mt-0.5 shrink-0 text-base">{icon}</span>
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium text-gray-800 dark:text-gray-200">
                  {att.filename}
                </p>
                {att.notes && (
                  <p className="text-xs text-gray-500">{att.notes}</p>
                )}

                {att.type === 'image' && (
                  <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="mt-1 inline-block">
                    <img
                      src={fileUrl}
                      alt={att.filename}
                      className="max-h-32 max-w-full rounded object-contain border border-gray-200 hover:opacity-80 transition-opacity cursor-pointer"
                    />
                  </a>
                )}
                {att.type === 'voice' && (
                  <audio controls className="mt-1 h-8 w-full max-w-[260px]">
                    <source src={fileUrl} type={att.mimeType} />
                  </audio>
                )}
                {att.type === 'video' && (
                  <div className="mt-1">
                    <video controls className="max-h-40 w-full max-w-[320px] rounded">
                      <source src={fileUrl} type={att.mimeType} />
                    </video>
                  </div>
                )}
                {att.type === 'document' && (
                  <a
                    href={fileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-1 inline-block rounded bg-brand-500 px-3 py-1 text-xs text-white hover:bg-brand-600"
                  >
                    View / Download
                  </a>
                )}
              </div>
            </div>
          );
        })}
      </div>
      <p className="mt-2 text-xs text-gray-400">You can only view files shared by HR.</p>
    </div>
  );
};

export default StudentAttachmentsView;
